import queryString from 'query-string';
import { get } from './apiUtils';

const defaultUrl = '/exceptions/';

export default {
  getExceptionList: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
};
